import React from 'react'
import '../App.css'
const Hospital = () => {

  return (
    <div><div className='listofhospitals'>Hello
    list here</div>
      <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d56985.2285460499!2d82.15796806738774!3d26.789757320681737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1shospitals!5e0!3m2!1sen!2sin!4v1698433239817!5m2!1sen!2sin" title='map' className='map'></iframe></div>
  )
}

export default Hospital